import React from 'react';
import { Helmet } from 'react-helmet';

export default function Allorders() {
  return ( <>
    <Helmet>
                <meta charSet="utf-8" />
                <meta name='description' content='All Orders'/>
                <title>FreshCart | All Orders</title>
    </Helmet>
    <div>Allorders</div>
  </>)
}
